export const LEARNICS_EXTENSION_KEYS = {
  studentLink: {
    prod: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1XwBJlTMngdFVMj0APW8COhiw7V/spGqFN00tdMBx2eLnPT6qyuhQLBPfSX0dGM2CQpsFcc62elz7aNqhdK/1c78PZiJMOSfUMB8m6MVMpvA5fFxMifBKiDLxVHUia3kybzrzzYC+Daf+vHXhTU8FCxwaz+yvKfPeh0HdWJWdRa68KvSG+0+QjCW1QKvuTKAtGEkNT1vySt41cApJ6/YiB5pAPSEv4qT/62RhJWOR5Zau6ONo3IDYhITG2cohZxlaH3Ca43p5ZrZBNAfOR7sRk7vFYhiYuzHtMktRMYqJxjhX1tB1AncEC5p4TQ4eNGtaBdVU5GuDe1gKG5A1bO7PwIDAQAB',
    staging:
      'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyhogfCyGHU9hfEfRYh+wkPV7v/EYmeCxwpNQRoMkEtvdmObm1Yz2vyfyL42xqw0aQTR5TA3NJn93lAQn4jaUJzurBoMR0JbJSgPCSQEfTjadBDIYpdvbysHfYDRlECzKNpV/U5ey2UvNwPINEQ61HNezfbwOelgsF/IIjvW1mUGpkcdblHEeKcMMqrApbQMU2x0RtrdgD9m+Qc0hXC1n7H0vSSdNGn7AaGdo/QK4+p44Bhyy2ZULtN2nJhJTs5Tuq6NIp340tXucMTSje2LSWBeH/90BS6wZQNnp5weM/w2QD9AT+A7SxmQ/PHKWktUyPYrhbuHTM48ltCHFu4EKBQIDAQAB',
  },
  classroomPro: {
    prod: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiQmdohNR7+xFs7nIbYpzex7Yq/s1ZAiGSxMd85ODrtjel6CE2jtYgpbQ7SodOIJkPrWuNLpjGRBjM6SPHCmP2ywkLUl5ZmpqiZqFlBGJTs+2AdGK6XkaKZdSawUZwQlXY9MU7vHwmIP/DxnsHK6ZrqVxk/1dqfuRiOEyPTgDhyJifEHLPWK/mQxrxzruSkXqh8IGlloce4JazWsxhGaO5UAXzPCFS32mWe6Pto55Jlvay+26i9cCwTNH8Yhta38ZYJWdGzWq+iyDnfQnBU8CFhVNLwkBWccHI4vFM+ADyPQ2ascPiiFDeJlDRtuEpOjO9W19GFMXcxn/uQlpSlc34QIDAQAB',
    staging:
      'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA81r2xsDjdtDylkCS4c16snRUcEFXbwQ+dBksHRNxWbolidNdAQpLCilOtX3GK2rsmYYo3SwwOTrF9BlcS2vz+typ41AXH3PEAybx4N/xDIhloFpEbRfgLV0oiCXn9dGl2AOFbqO9Fs2yIxvNrZMNP051MoCGR2gB8GEAmpICLv6TiZxbtUbTb8PTbZohVgpMW5gc555o6R1V97jaY5yZD0CwGBI3SxmaVtYhTpti3U9YwU30Bq2iwt+Lg9iPlMX7qJ9pHK8ZzUHsl4YUSVi0fXlgNvFJ9Ce3GPvRlTLB09cSDDr2Z9qQrmrmAYZgHNduZTctBfOnmkds/qRy/TjAZQIDAQAB',
  },
  oneClick: {
    prod: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAyM54BL2aucAnGIUORV/mRBKx8NFz1JoDgRjZjbE9dz1zjEd1O6nZZ5n7ucuYPRw092eKl42JV4gn5ewthvPBDihm4J7nrqrEv9W8yfFzZMy8JASPzpKkcXs/ZVKMbanUIKiXdPcHqL1PVHd7pWKX8n9G60t27jEOfFBnOEyVhm0GG/bcmf+flykek57SaQt+FyPsJ1ZsTCwW2f44vGZCLyxLWcyg/5URKIip51Wh4fuYg+pehbjnBzXeehynvvrjHiCG6Wq9V722I2L5hhjSr6/03In18lFwGUzKWG83h5v734aREnRHq4cRIJ5+SAK4KK70oAuDp4ID0LK2q/ZzBwIDAQAB',
    staging:
      'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAusDZNXGSroDLN0Lm5DTNoa36SujVuNCwKjJycch3P4c63kf06Qz3f8ICxMwMzcLixp7R56ZLhD/KYbwq3iIBQ39wNJjXFxaKCI0TEufmOErEDBfqo//y3ubWl2Bc8QcXeGPsk7DsdL6tPXnDGmlkY9W/HmiZoQCt4s/evY7gp+rkYyulLrKFJpBupylsYoVi/eGNKPZ/34IcBiwQPYn9Yf/Z15a3FPvdx9DILTX7Xpj0BzMr5/tlQvabF66JjyMDj7gK7SnJk/8oWFWMbVC+BikR0ReUJPm43ZnX0Gnx7edVkiyl1eWmuph2oAA9Rlz9nOwEdXXOiohOkVLlGOhCRwIDAQAB',
  },
}

export const LEARNICS_EXTENSION_IDS = {
  studentLink: {
    prod: 'hlpffihikpginaficljilffbkeanfcpg',
    staging: 'iadkpahpfflmckpgnliggohlnomonplg',
  },
  classroomPro: {
    prod: 'nhdacjmkhimeohpnahfmdmcknaneeffk',
    staging: 'faedhjidmjcbhmibbdokmkbkofbaklbg',
  },
  oneClick: {
    prod: 'jlhemnnjmgaaaklbcdpiafnkgibjnoed',
    staging: 'njoibpijbipnpchnkaobaplfgldelgio',
  },
}

export function getExtensionDistributionType(extensionId) {
  const distributionTypes = Object.keys(LEARNICS_EXTENSION_IDS)
  for (const distributionType of distributionTypes) {
    const deploymentTypes = Object.keys(
      LEARNICS_EXTENSION_IDS[distributionType],
    )
    for (const deploymentType of deploymentTypes) {
      if (
        LEARNICS_EXTENSION_IDS[distributionType][deploymentType] === extensionId
      ) {
        return distributionType
      }
    }
  }
  return null
}

export function getExtensionDeploymentType(extensionId) {
  const distributionTypes = Object.keys(LEARNICS_EXTENSION_IDS)
  for (const distributionType of distributionTypes) {
    const deploymentTypes = Object.keys(
      LEARNICS_EXTENSION_IDS[distributionType],
    )
    for (const deploymentType of deploymentTypes) {
      if (
        LEARNICS_EXTENSION_IDS[distributionType][deploymentType] === extensionId
      ) {
        return deploymentType
      }
    }
  }
  return null
}

export function getAllExtensionIds(
  filter = (distributionType, deploymentType, extensionId) => true,
) {
  const result = []
  for (const distributionType of Object.keys(LEARNICS_EXTENSION_IDS)) {
    for (const deploymentType of Object.keys(
      LEARNICS_EXTENSION_IDS[distributionType],
    )) {
      if (
        !filter(
          distributionType,
          deploymentType,
          LEARNICS_EXTENSION_IDS[distributionType][deploymentType],
        )
      ) {
        continue
      }
      result.push(LEARNICS_EXTENSION_IDS[distributionType][deploymentType])
    }
  }
  return [...new Set(result)]
}
